

export default {
  OPP_NO_TAXPAYERID_REASON_DICT_NAME: [{
    DICT_ITEM: "1",
    DICT_ITEM_NAME: "居民国(地区)不发放纳税人识别号"
  }, {
    DICT_ITEM: "2",
    DICT_ITEM_NAME: "账户持有人未能取得纳税人识别号"
  }],
  addCreditModule: function addCreditModule(_this, moduleObj, isDelete) {
    var creditRecord = _.get(_this, "groupDatas.TAX_INFO.CREDIT_INFO"),
        creditLen = creditRecord.length,
        lastMd = !isDelete ? moduleObj : creditRecord[creditLen - 1];
    if (creditLen > 1) {
      var hasCheck = [];
      _.each(_.cloneDeep(creditRecord).slice(0, creditLen - 1), function (v) {
        if (v.FIELDS.RECORD_SOURCE.DEFAULT_VALUE && v.FIELDS.RECORD_SOURCE.DEFAULT_VALUE != "") {
          hasCheck.push(v.FIELDS.RECORD_SOURCE.DEFAULT_VALUE);
        }
      });
      lastMd.FIELDS.RECORD_SOURCE.FIELD_DICT_NAME = _.filter(creditRecord[0].FIELDS.RECORD_SOURCE.FIELD_DICT_NAME, function (v) {
        return hasCheck.indexOf(v.DICT_ITEM) == -1 && v.DICT_ITEM != "ZZ";
      });
      if (!isDelete) {
        creditRecord[creditLen - 2].FIELDS.RECORD_SOURCE.FIELD_CONTROL = "2";
      } else {
        creditRecord[creditLen - 1].FIELDS.RECORD_SOURCE.FIELD_CONTROL = "0";
      }
    } else {
      _.set(lastMd, "FIELDS.RECORD_SOURCE.FIELD_CONTROL", "0");
    }
  },
  checkAddress: function checkAddress(address) {
    var addStr = address && address.slice(address.length - 1),
        addArr = ["号", "户", "室", "组"];
    if (address && addArr.indexOf(addStr) < 0) {
      return false;
    }
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/QS420_tools.js
// module id = 59
// module chunks = 2